import Actions                           from 'Redux/Actions';
import { OrganisationInvoiceRepository } from 'Domain/Repositories';
import { ofType }                        from 'redux-observable';
import { from, EMPTY }                   from 'rxjs';
import { mergeMap }                      from 'rxjs/operators';
import { TEpic }                         from 'Redux/Config';

export const findOrganisationInvoiceEpic: TEpic = (action$) => {
  return action$.pipe(
    ofType(Actions.findOrganisationInvoiceRequest.type),
    mergeMap(action => {
      const { id } = action.payload;

      if (!id.trim()) {
        return EMPTY;
      }

      return from(
        OrganisationInvoiceRepository.findById(id)
          .then((organisationInvoice) => Actions.findOrganisationInvoiceSuccess({ organisationInvoice }))
          .catch(error => Actions.findOrganisationInvoiceFailure({ error })),
      );
    }),
  );
};
